require('./payrollLoanRequestOutcome.scss');
require('./payrollLoanRequestOutcome.override.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

//@core
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
// @commons
const { AmountInput } = require('commonsComponents/amountInput');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @components
const PayrollLoanRequestOutcomeWaffer = require('./payrollLoanRequestOutcomeWaffer/payrollLoanRequestOutcomeWaffer');
//@constants
const { EURO_SYMBOL, NUMBER_WITH_DECIMALS_REGEX, EMPTY_REGEX } = require('constants/index');
const { DEFAULT_LOANS_DECIMALS_LENGTH, MAX_LENGTH_NUMBER_INPUT } = require('../../../../../loansConstants/index');

class PayrollLoanRequestOutcome extends React.Component {

    constructor(props) {
        super(props);

        this.onMortgageChange = this.onMortgageChange.bind(this);
        this.onRentChange = this.onRentChange.bind(this);
        this.onOthersChange = this.onOthersChange.bind(this);
        this.handleAccept = this.handleAccept.bind(this);
    }

    componentDidMount() {
        const {
            formHandlers,
            getLoansForExpenses,
            immContractLoan,
        } = this.props;
        const purpose = immContractLoan.get('selectedPurpose');

        getLoansForExpenses();

        if (purpose !== '') {
            formHandlers.handleSaveInProgress();
        }
    }

    onMortgageChange(mortgage) {
        if (NUMBER_WITH_DECIMALS_REGEX.test(mortgage) || (EMPTY_REGEX.test(mortgage))) {
            const { immContractLoan } = this.props;
            const immOutcome = immContractLoan.get('outcome');
            this.handleAccept(mortgage, immOutcome.get('rent'), immOutcome.get('others'));
        }
    }

    onOthersChange(others) {
        if (NUMBER_WITH_DECIMALS_REGEX.test(others) || (EMPTY_REGEX.test(others))) {
            const { immContractLoan } = this.props;
            const immOutcome = immContractLoan.get('outcome');
            this.handleAccept(immOutcome.get('mortgage'), immOutcome.get('rent'), others);
        }
    }

    onRentChange(rent) {
        if (NUMBER_WITH_DECIMALS_REGEX.test(rent) || (EMPTY_REGEX.test(rent))) {
            const { immContractLoan } = this.props;
            const immOutcome = immContractLoan.get('outcome');
            this.handleAccept(immOutcome.get('mortgage'), rent, immOutcome.get('others'));
        }
    }

    buildEuroSymbol() {
        const { isDragoFeature } = this.props;

        const euroSymbolCalssName = classNames({
            'payroll-loan-request-outcome__container-drago-euro-symbol': isDragoFeature,
            'col-xs-1 payroll-loan-request-outcome__container-euro-symbol': !isDragoFeature
        });

        return (
            <div className={euroSymbolCalssName}>
                <span className="payroll-loan-request-outcome__euro-symbol">{EURO_SYMBOL}</span>
            </div>
        );
    }

    buildTooltip(content) {
        return (
            <OKTooltip
                content={formatText(content)}
                type="explicative"
                modifier="dark-bg"
            />
        );
    }

    buildOtherOutcomesContent() {
        const {
            immContractLoan,
            isDragoFeature,
        } = this.props;

        const isCallingSaveInProgress = immContractLoan.get('isCallingSaveInProgress');
        const immOutcome = immContractLoan.get('outcome');

        const language = getLanguage();
        const euroSymbol = this.buildEuroSymbol();

        const inlineUnit = isDragoFeature ? euroSymbol : null;
        const euroSymbolComponent = !isDragoFeature ? euroSymbol : null;

        const mortgage = immOutcome.get('mortgage');
        const rent = immOutcome.get('rent');
        const others = immOutcome.get('others');

        const tooltipRent = this.buildTooltip('payrollLoanRequestStepOne-rentalInstruction');
        const tooltipMortgage = this.buildTooltip('payrollLoanRequestStepOne-mortgageLoansInstruction');
        const tooltipOtherLoans = this.buildTooltip('payrollLoanRequestStepOne-monthlyFeesInstruction');


        const classStylesRent = classNames('col-xs-4', {
            'payroll-loan-request-outcome__input': rent,
            'payroll-loan-request-outcome__input-without-value': !rent
        });

        const classStylesMortgage = classNames('col-xs-4', {
            'payroll-loan-request-outcome__input': mortgage,
            'payroll-loan-request-outcome__input-without-value': !mortgage
        });

        const classStylesOtherLoans = classNames('col-xs-4', {
            'payroll-loan-request-outcome__input': others,
            'payroll-loan-request-outcome__input-without-value': !others
        });

        return (
            <div className="container-fluid">
                <div className="row payroll-loan-request-outcome__container-section">
                    <div className="col-xs-7">
                        <div className="payroll-loan-request-outcome__container-titles">
                            <FormattedText
                                className="payroll-loan-request-outcome__label"
                                value="payrollLoanRequestStepOne-rental"
                            />
                            {tooltipRent}
                        </div>
                    </div>
                    <div className={classStylesRent}>
                        <AmountInput
                            amount={rent}
                            callback={this.onRentChange}
                            disabled={isCallingSaveInProgress}
                            min={0}
                            maxBackEndFractionLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                            maxFractionLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                            maxIntegerLength={MAX_LENGTH_NUMBER_INPUT}
                            hideFocusZero
                            showBlurZero
                            fluid
                            language={language}
                            inlineUnit={inlineUnit}
                        />
                    </div>
                    {euroSymbolComponent}
                </div>
                <div className="row payroll-loan-request-outcome__container-section">
                    <div className="col-xs-7">
                        <div className="payroll-loan-request-outcome__container-titles">
                            <FormattedText
                                className="payroll-loan-request-outcome__label"
                                value="payrollLoanRequestStepOne-mortgageLoans"
                            />
                            {tooltipMortgage}
                        </div>
                    </div>
                    <div className={classStylesMortgage}>
                        <AmountInput
                            amount={mortgage}
                            callback={this.onMortgageChange}
                            disabled={isCallingSaveInProgress}
                            min={0}
                            maxBackEndFractionLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                            maxFractionLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                            maxIntegerLength={MAX_LENGTH_NUMBER_INPUT}
                            hideFocusZero
                            showBlurZero
                            fluid
                            language={language}
                            inlineUnit={inlineUnit}
                        />
                    </div>
                    {euroSymbolComponent}
                </div>
                <div className="row payroll-loan-request-outcome__container-section">
                    <div className="col-xs-7">
                        <div className="payroll-loan-request-outcome__container-titles">
                            <FormattedText
                                className="payroll-loan-request-outcome__label"
                                value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_monthlyFees"
                            />
                            {tooltipOtherLoans}
                        </div>
                    </div>
                    <div className={classStylesOtherLoans}>
                        <AmountInput
                            amount={others}
                            callback={this.onOthersChange}
                            disabled={isCallingSaveInProgress}
                            min={0}
                            maxBackEndFractionLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                            maxFractionLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                            maxIntegerLength={MAX_LENGTH_NUMBER_INPUT}
                            hideFocusZero
                            showBlurZero
                            fluid
                            language={language}
                            inlineUnit={inlineUnit}
                        />
                    </div>
                    {euroSymbolComponent}
                </div>
            </div >
        )
    }

    handleAccept(mortgage, rent, others) {
        const { onAccept } = this.props;

        onAccept({
            mortgage,
            rent,
            others
        });
    }

    buildWaffer(itemsList) {
        const {
            immContractLoan,
            isDragoFeature,
        } = this.props;

        const currency = immContractLoan.get('currency');
        const otherOutcomesContent = this.buildOtherOutcomesContent();
        const immOutcome = immContractLoan.get('outcome');

        const mortgage = immOutcome.get('mortgage');
        const rent = immOutcome.get('rent');
        const others = immOutcome.get('others');
        const sumOtherLoansAndMortgages = rent + mortgage + others;
        const separatorComponent = isDragoFeature ?
            (<div className="payroll-loan-request-outcome__separator" />) : null;

        return itemsList ? (
            <React.Fragment>
                <PayrollLoanRequestOutcomeWaffer
                    currency={currency}
                    outstandedLabel={formatText('payrollLoanRequestStepOne-payrollLoanRequestStepOne_totalExpenses')}
                    itemsList={itemsList}
                    otherOutcomesContent={otherOutcomesContent}
                    sumOtherLoansAndMortgages={sumOtherLoansAndMortgages}
                />
                {separatorComponent}
            </React.Fragment>
        ) : null;
    }

    buildTitleOutcome() {
        return (
            <FormattedText
                value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_outcomeTitle"
                className="payroll-loan-request-outcome__title-sliders"
            />
        );
    }

    render() {
        const {
            className,
            immContractLoan,
            isDragoFeature,
        } = this.props;

        const immLoans = immContractLoan.get('loans');
        const isFetchingLoans = immContractLoan.get('isFetchingLoans');
        const title = isDragoFeature ? this.buildTitleOutcome() : null;
        const waffer = this.buildWaffer(immLoans.toJS());


        return !isFetchingLoans ? (
            <div className={className}>
                {title}
                <FormattedText
                    value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_monthlyOutcome"
                    className="payroll-loan-request-outcome__input-button-label"
                />
                {waffer}
            </div>
        ) :
            (
                <div className={className}>
                    <LoadingSection />
                </div>
            );
    }
}

PayrollLoanRequestOutcome.propTypes = {
    className: PropTypes.string.isRequired,
    formHandlers: PropTypes.object.isRequired,
    getLoansForExpenses: PropTypes.func.isRequired,
    immContractLoan: PropTypes.object.isRequired,
    isDragoFeature: PropTypes.bool.isRequired,
    onAccept: PropTypes.func.isRequired,
};

module.exports = PayrollLoanRequestOutcome;
